export const detectBrowserLanguage = () => navigator?.languages?.[0];
